import AccountCircleIcon from '@mui/icons-material/AccountCircle';

export const Profile = () => <AccountCircleIcon fontSize="medium" />;
